import type { WorkflowInstanceDto } from '@/api/origin-workflow-svc'
import constants from '@/config/constants'

// The model ids the My Work dashboard knows how to render. These mirror the
// branches in `prepareWorkflowData`/`header`/`handleOpenWorkflowDetail` on the
// dashboard page — the only workflow types it can build rows, a progress bar
// and a detail route for.
const RENDERABLE_MODEL_IDS = new Set(
  Object.values(constants.WORKFLOW_MODEL_IDS).map((id) => id.toLowerCase())
)

/**
 * DF-2764: `findAllForRequester` returns every workflow instance for the
 * requester — including Bronze id credential workflows
 * (BronzeIdStatusResponseDto carries `workflowInstanceId` + `workflowModelId`).
 * The My Work dashboard can only render the three vLEI prerequisite workflows;
 * an unknown model id (e.g. a bronze workflow) otherwise falls through every
 * branch and surfaces as a blank workflow row. Use this predicate to keep the
 * list to the workflows the dashboard actually supports.
 */
export const isRenderableMyWorkWorkflow = (
  workflow: WorkflowInstanceDto
): boolean => {
  const modelId = workflow.workflowModelId?.toLowerCase()
  return modelId !== undefined && RENDERABLE_MODEL_IDS.has(modelId)
}
